import {
  discardActiveObjectInStore,
} from '@/components/Editor/helpers/fabric/activeObjects/modifyActiveObjectInStore';
import { FabricCanvas } from '@/components/Editor/types/fabric';

export const selectionCleared = (canvas: FabricCanvas): void => {
  canvas.on('selection:cleared', discardActiveObjectInStore);
};
